module.exports = __webpack_public_path__ + "img/andrewse.e8ad1838.jpg";